import { getAuthHeaders } from '../../statistics/api/auth-headers';

/**
 * Шаблоны контактов для последнего слайда — общие для команды, хранятся на
 * бэкенде отчётов (/api, Fastify). Маршруты требуют JWT пользователя сайта.
 */

export type ContactTemplateInput = {
  name: string;
  role: string;
  email: string;
  phone: string;
  telegram: string;
};

export type ContactTemplate = ContactTemplateInput & {
  id: string;
  createdAt: string;
  updatedAt: string;
};

const BASE = '/api/presentation/contacts';

async function request<T>(url: string, init: RequestInit = {}): Promise<T> {
  const headers = await getAuthHeaders();
  // Fastify отвечает 400 на JSON-заголовок при пустом теле (DELETE, GET).
  if (init.body === undefined) delete headers['Content-Type'];
  const res = await fetch(url, { ...init, headers: { ...headers, ...init.headers } });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error || `Ошибка сервера: ${res.status}`);
  }
  return (res.status === 204 ? undefined : await res.json()) as T;
}

export const contactTemplatesApi = {
  async list(): Promise<ContactTemplate[]> {
    return (await request<{ contacts: ContactTemplate[] }>(BASE)).contacts;
  },

  async create(input: ContactTemplateInput): Promise<ContactTemplate> {
    const body = JSON.stringify(input);
    return (await request<{ contact: ContactTemplate }>(BASE, { method: 'POST', body })).contact;
  },

  async update(id: string, input: ContactTemplateInput): Promise<ContactTemplate> {
    const body = JSON.stringify(input);
    const url = `${BASE}/${encodeURIComponent(id)}`;
    return (await request<{ contact: ContactTemplate }>(url, { method: 'PUT', body })).contact;
  },

  async remove(id: string): Promise<void> {
    await request<void>(`${BASE}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  },
};
